import React, { useEffect, useState } from 'react';
import Aos from 'aos';
import "aos/dist/aos.css";
//images
//images
import Laravel from '../assets/works/laravel.png';
import ReactPng from '../assets/works/react.png';
import Tailwind from '../assets/works/tailwind.png';

const Skills = () => {
    const skills = [
      {
        title: 'React',
        image: ReactPng
      },
      {
        title: 'Laravel',
        image: Laravel
      },
      {
        title: 'Tailwind',
        image: Tailwind
      }
    ];

    useEffect(()=>{
      Aos.init({duration: 2000});
      return () => {
        Aos.refresh(); // Refresh AOS on component unmount
      };
    }, []);
  return (
    <div name='skills' className='w-full h-screen bg-[#0a192f] text-gray-300'>
      {/* Container */}
      <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
          <div>
              <p className='text-4xl font-bold inline border-b-4 border-pink-600 '>Skills</p>
              <p className='py-4 ml-2 text-xl'>These are the technologies I've worked with</p>
          </div>
          <div data-aos="fade-left" className='w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8'>
            {skills && (
                skills.map((skill, index)=>(
                    <div className='shadow-md shadow-[#040c16] hover:scale-110 duration-500' key={index}>
                        <img className='w-28 mx-auto' src={skill.image} alt={skill.title} />
                        <p className='my-4'>{skill.title}</p>
                    </div>
                ))
                )}
            </div>
      </div>
    </div>
  );
};

export default Skills;
